// sectionUtils.ts
// Shared pure utilities for template section components.
// Kept in a separate file to avoid circular imports when NavSection / FooterSection
// need utilities that are also consumed by sections still living in TemplateSections.tsx.

/**
 * Returns the CSS class string for a template button variant.
 * Variants map to CSS modifier classes defined in template.css.
 */
export function btnClass(
  variant: "primary" | "ghost" | "invertOnAccent" | "onImage" = "primary",
): string {
  const mod =
    variant === "primary"
      ? "mte-tpl-btn--primary"
      : variant === "ghost"
        ? "mte-tpl-btn--ghost"
        : variant === "invertOnAccent"
          ? "mte-tpl-btn--invert-accent"
          : "mte-tpl-btn--on-image";
  return `mte-tpl-btn ${mod}`;
}
